export default "__VITE_ASSET__M9pTd1J0__"